<template lang="pug">
eventengine
  floating
  minigamesModal
  betSingleModal
  betSingleStatus
  betParlayModal
  betParlayStatus
  //- betResultModal
  betSingleMMOModal
  betSingleMMOStatus
  betParlayMMOModal
  betParlayMMOStatus
  searchModal
  //- leagueModal
  nicknameModal
  passwordModal
  languageModal
  allSportsModal
  oddsTypeModal
  defaultEventSortingModal
  drawer
  //- template(v-if="!whiteLabel && !mmoMode")
  //-   .minigame-nav(data-toggle='modal' data-target='#minigame')
  //-     img(src='images/floating_minigame.png')
  router-view
  topButton
</template>

<script>
import config from "@/config";
import eventengine from "@/components/eventEngine";
import floating from "@/components/mobile/floating";

import betSingleModal from "@/components/mobile/bets/new/betSingleModal";
import betSingleStatus from "@/components/mobile/bets/new/betSingleStatus";
import betParlayModal from "@/components/mobile/bets/new/betParlayModal";
import betParlayStatus from "@/components/mobile/bets/new/betParlayStatus";

import betSingleMMOModal from "@/components/mobile/bets/mmo/betSingleModal";
import betSingleMMOStatus from "@/components/mobile/bets/mmo/betSingleStatus";
import betParlayMMOModal from "@/components/mobile/bets/mmo/betParlayModal";
import betParlayMMOStatus from "@/components/mobile/bets/mmo/betParlayStatus";

import minigamesModal from "@/components/mobile/minigamesModal";



// import betResultModal from "@/components/mobile/bets/betResultModal";
import searchModal from "@/components/mobile/searchModal";
import leagueModal from "@/components/mobile/leagueModal";
import nicknameModal from "@/components/mobile/account/nicknameModal";
import passwordModal from "@/components/mobile/account/passwordModal";
import languageModal from "@/components/mobile/account/languageModal";
import oddsTypeModal from "@/components/mobile/account/oddsTypeModal";
import defaultEventSortingModal from "@/components/mobile/account/defaultEventSortingModal";
import allSportsModal from "@/components/mobile/account/allSportsModal";
import drawer from "@/components/mobile/drawer";
import topButton from "@/components/mobile/topButton";

export default {
  components: {
    eventengine,
    minigamesModal,
    floating,
    betSingleModal,
    betSingleStatus,
    betParlayModal,
    betParlayStatus,
    // betResultModal,
    betSingleMMOModal,
    betSingleMMOStatus,
    betParlayMMOModal,
    betParlayMMOStatus,
    searchModal,
    leagueModal,
    nicknameModal,
    passwordModal,
    languageModal,
    oddsTypeModal,
    defaultEventSortingModal,
    allSportsModal,
    drawer,
    topButton
  },
  computed: {
    whiteLabel() {
      return config.whiteLabel == "1";
    },
    mmoMode() {
      return this.$store.getters.mmoMode;
    }
  }
};
</script>
